import { render, staticRenderFns } from "./contattaci.vue?vue&type=template&id=4e245d2a"
import script from "./contattaci.vue?vue&type=script&lang=js"
export * from "./contattaci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports